import styles from '../Styles/SuccessCases.module.css';
import Container from '../UI/Container';
import SectionTitle from '../UI/SectionTitle';

const casesData = [
  {
    id: 1,
    badge: 'CCTV',
    service: 'Closed-Circuit Television',
    location: 'Local Comercial · Bogotá',
    title: 'Vigilancia total para local comercial',
    problem: 'El negocio no contaba con ningún sistema de vigilancia, generando pérdidas por hurto sin posibilidad de identificar responsables.',
    solution: 'Instalación de 6 cámaras IP con visión nocturna, DVR y acceso remoto desde el celular del propietario las 24 horas.',
    // Reemplaza estas rutas cuando el cliente envíe las imágenes reales
    imgBefore: null,
    imgAfter: null,
    iconBefore: (
      <svg width="44" height="44" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="9" stroke="rgba(255,255,255,0.15)" strokeWidth="1.5"/>
        <path d="M9 10h6M9 14h6" stroke="rgba(255,255,255,0.15)" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
    ),
    iconAfter: (
      <svg width="44" height="44" viewBox="0 0 24 24" fill="none">
        <path d="M12 2L3 7v5c0 5.25 3.75 10.15 9 11.35C17.25 22.15 21 17.25 21 12V7L12 2z"
          stroke="#00AACD" strokeWidth="1.5" strokeLinecap="round"/>
        <path d="M9 12l2 2 4-4" stroke="#00AACD" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
    ),
  },
  {
    id: 2,
    badge: 'LAN',
    service: 'Local Area Network',
    location: 'Oficina Corporativa · Medellín',
    title: 'Red estructurada para 30 puestos de trabajo',
    problem: 'Cableado desorganizado y red saturada causando cortes frecuentes que reducían la productividad del equipo de trabajo.',
    solution: 'Reestructuración completa del rack de datos, cableado UTP Cat6 certificado y configuración de switches para máxima velocidad.',
    imgBefore: null,
    imgAfter: null,
    iconBefore: (
      <svg width="44" height="44" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="4" stroke="rgba(255,255,255,0.15)" strokeWidth="1.5"/>
        <path d="M5 12H3M21 12h-2M12 5V3M12 21v-2"
          stroke="rgba(255,255,255,0.15)" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
    ),
    iconAfter: (
      <svg width="44" height="44" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="4" stroke="#00AACD" strokeWidth="1.5"/>
        <path d="M5 12H3M21 12h-2M12 5V3M12 21v-2M18.364 5.636l-1.414 1.414M7.05 16.95l-1.414 1.414M18.364 18.364l-1.414-1.414M7.05 7.05L5.636 5.636"
          stroke="#00AACD" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
    ),
  },
  {
    id: 3,
    badge: 'TEC',
    service: 'Technical Expert Center',
    location: 'PyME · Cúcuta',
    title: 'Recuperación total del parque tecnológico',
    problem: '10 equipos con bajo rendimiento, sobrecalentamiento y fallas de software que detenían la operación diaria de la empresa.',
    solution: 'Mantenimiento preventivo y correctivo completo, actualización de componentes clave y optimización de software en todos los equipos.',
    imgBefore: null,
    imgAfter: null,
    iconBefore: (
      <svg width="44" height="44" viewBox="0 0 24 24" fill="none">
        <rect x="2" y="3" width="20" height="14" rx="2"
          stroke="rgba(255,255,255,0.15)" strokeWidth="1.5"/>
        <path d="M8 21h8M12 17v4"
          stroke="rgba(255,255,255,0.15)" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
    ),
    iconAfter: (
      <svg width="44" height="44" viewBox="0 0 24 24" fill="none">
        <rect x="2" y="3" width="20" height="14" rx="2"
          stroke="#00AACD" strokeWidth="1.5"/>
        <path d="M8 21h8M12 17v4"
          stroke="#00AACD" strokeWidth="1.5" strokeLinecap="round"/>
        <path d="M8 10l2 2 4-4"
          stroke="#00AACD" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
    ),
  },
];

const ArrowDown = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M12 5v14M6 13l6 6 6-6" stroke="#00AACD" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

const SuccessCases = () => {
  return (
    <section id="proyectos" section className={styles.cases}>

      {/* ── Decorativos ── */}
      <div className={styles.orbTl} />
      <div className={styles.orbBr} />

      <Container>
        <SectionTitle
          title="Casos de Éxito"
          subtitle="Soluciones reales que transformaron negocios y hogares"
          highlight="Éxito"
          light={true}
        />

        <div className={styles.grid}>
          {casesData.map((c) => (
            <div key={c.id} className={styles.flipCard}>
              <div className={styles.flipInner}>

                {/* ── CARA FRONTAL ── */}
                <div className={styles.flipFront}>
                  <div className={styles.imagesCol}>

                    {/* Antes */}
                    <div className={styles.imgSlotBefore}>
                      {c.imgBefore
                        ? <img src={c.imgBefore} alt={`Antes — ${c.title}`} className={styles.realImg} />
                        : c.iconBefore
                      }
                      <span className={styles.imgLabel}>Antes</span>
                    </div>

                    {/* Divisor con flecha */}
                    <div className={styles.imgDivider}>
                      <div className={styles.arrowSep}><ArrowDown /></div>
                    </div>

                    {/* Después */}
                    <div className={styles.imgSlotAfter}>
                      {c.imgAfter
                        ? <img src={c.imgAfter} alt={`Después — ${c.title}`} className={styles.realImg} />
                        : c.iconAfter
                      }
                      <span className={styles.imgLabel}>Después</span>
                    </div>

                  </div>

                  <span className={styles.hoverHint}>↺ Pasa el cursor para ver el caso</span>

                  <div className={styles.frontFooter}>
                    <span className={styles.frontTitle}>{c.location}</span>
                    <span className={styles.frontBadge}>{c.badge}</span>
                  </div>
                </div>

                {/* ── CARA TRASERA ── */}
                <div className={styles.flipBack}>
                  <span className={styles.backBadge}>{c.service}</span>
                  <h3 className={styles.backTitle}>{c.title}</h3>
                  <div className={styles.backDivider} />
                  <div className={styles.backBlock}>
                    <p className={styles.backSectionLabel}>El problema</p>
                    <p className={styles.backText}>{c.problem}</p>
                  </div>
                  <div className={styles.backBlock}>
                    <p className={styles.backSectionLabel}>La solución</p>
                    <p className={styles.backText}>{c.solution}</p>
                  </div>
                </div>

              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default SuccessCases;